import { useEffect } from "react";

export const StatusBar = ({ background }: { background: string }) => {
  useEffect(() => {
    document.body.style.background = background;
  }, [background]);

  return null;
};
